import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsuarioLogadoModel } from '../../../app/models/usuario.model';

@Injectable()
export class CompartilhadoUsuarioService {

    constructor(private http: HttpClient) { }

    public esconderLoading = false;
    public ocultarMenu = true;

    public obterTokenUsuario(): string {
        return localStorage.getItem('token');
    }

    private obterNome(): string {
        return localStorage.getItem('nome');
    }

    private obterIdPerfil(): string {
        return localStorage.getItem('idPerfil');
    }

    private obterEmail(): string {
        return localStorage.getItem('email');
    }

    public obterIdUsuario(): string {
        return localStorage.getItem('id');
    }

    public obterIniciaisUsuario(): string {
        return localStorage.getItem('iniciais');
    }

    private obterInstituicaoAssociada(): string {
        return localStorage.getItem('instituicaoAssociada') || this.obterInstituicaoAssociadaToken();
    }

    public armazenarUsuarioLogado(usuario: UsuarioLogadoModel): void {
        localStorage.setItem('id', usuario.id);
        localStorage.setItem('idPerfil', usuario.idPerfil);
        localStorage.setItem('nome', usuario.nome);
        localStorage.setItem('email', usuario.email);
        localStorage.setItem('token', usuario.token);
        localStorage.setItem('iniciais', usuario.iniciais);
        localStorage.setItem('instituicaoAssociada', usuario.instituicaoAssociada || '');
    }

    public removerUsuarioLogado(): void {
        localStorage.clear();
    }


    public obterUsuarioLogado(): UsuarioLogadoModel {
        if (!this.obterIdUsuario()) {
            return null;
        }

        const response = new UsuarioLogadoModel(
            this.obterIdUsuario(),
            this.obterIdPerfil(),
            this.obterNome(),
            this.obterEmail(),
            this.obterTokenUsuario(),
            this.obterIniciaisUsuario(),
            this.obterInstituicaoAssociada()
        )
                               
        return response;
    }

    private obterInstituicaoAssociadaToken(): string {
        const token = this.obterTokenUsuario();
        if (!token) {
            return '';
        }

        try {
            const partes = token.split('.');
            if (partes.length < 2) {
                return '';
            }

            const base64 = partes[1].replace(/-/g, '+').replace(/_/g, '/');
            const payload = JSON.parse(decodeURIComponent(atob(base64).split('').map(c =>
                '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            ).join('')));

            const chavesPreferenciais = [
                'instituicaoAssociada',
                'instituicao_associada',
                'nomeInstituicao',
                'nome_instituicao',
                'razaoSocial',
                'razao_social',
                'associado'
            ];

            for (const chave of chavesPreferenciais) {
                const valor = payload[chave];
                if (typeof valor === 'string' && valor.trim()) {
                    return valor.trim();
                }
            }

            const chaveInstituicao = Object.keys(payload).find(chave => {
                const nome = chave.toLowerCase();
                return nome.includes('instituicao') && !nome.includes('id');
            });

            const valor = chaveInstituicao ? payload[chaveInstituicao] : '';
            return typeof valor === 'string' ? valor.trim() : '';
        } catch {
            return '';
        }
    }

}
